export default __webpack_public_path__ + "static/feedback@1x-9ed0c4c807ee87bd12fa41ec862429a0.webp";